import type { CostWithCurrency } from 'types/units';

export const ZERO_COST = Object.freeze<CostWithCurrency>({
  formatted: '0',
  amount: 0,
  fractional: 0,
  currency_code: '',
});
